(function (angular) {
    'use strict';

    angular.module('app')
        /**
         * Displays value with a selected currency symbol;
         * 
         * value: number
         * currencyCode: GBP, EUR, USD, PLN
         * fraction: number
         */
        .component('valueWithCurrency', {
            bindings: {
                value: '<',
                currencyCode: '<',
                fraction: '<'
            },
            controller: function () {
                var ctrl = this;
                ctrl.currencyMap = {
                    GBP: "&pound;",
                    EUR: "&euro;",
                    USD: "&dollar;",
                    PLN: "&#x7a;&#x142;"
                };
            },
            template: ' <span ng-bind-html="$ctrl.value | currency:$ctrl.currencyMap[$ctrl.currencyCode]:$ctrl.fraction"></span>'
        })

        //
        // PROGRESSBAR
        // currentStage should be a number, pointing to current stage in stages array
        // stages should be an array with 'stage' items defined in below format:
        // {
        // label: 'label name',
        // callback: cb
        // }
        // 
        .component('progressBar', {
            bindings: {
                stages: '<',
                currentStage: '<'
            },
            controller: function () {
                var ctrl = this;
            },
            templateUrl: './shared/componentTemplates/component.progressBar.html'
        })

        /**
         * Creates a toggle switch element
         * color: string: primary, warning, success, danger, info
         * label: string
         * model: string
         * onToggle: togle switch handler
         */
        .component('toggleSwitch', {
            bindings: {
                color: '@',
                label: '@',
                model: "=",
                onToggle: "&"
            },
            controller: ["$timeout", "utilService", function ($timeout, utilService) {
                var ctrl = this;
                ctrl.uuid = utilService.uuid();
                ctrl.toggleCallback = function () {
                    // WARNING: if you don't use $timeout, the model value in the parent hasn't been updated when we make this call
                    $timeout(function () {
                        ctrl.onToggle({ value: ctrl.model });
                    });
                }
            }],
            templateUrl: './shared/componentTemplates/component.toggleSwitch.html'
        })

        /** icon component
         * icon: string, icon name,
         * color: string, 
         * label: string,
         * disabled: boolean,
         * onClick: click handler,
         * className: string
         */
        .component('iconButtonCircle', {
            bindings: {
                icon: '@',
                color: '@',
                label: '@',
                disabled:"<",
                onClick: '&',
                className: "@"
            },
            controller: [function () {
                var ctrl = this;
                ctrl.$onInit = function () {
                    ctrl.className = ctrl.className || "btn-slim";
                };
            }],
            templateUrl: './shared/componentTemplates/component.iconButtonCircle.html'
        })

        /**
         * icon component
         * icon: string, icon name,
         * label: string,
         * onClick: click handler
         */
        .component('iconButton', {
            bindings: {
                icon: '@',
                label: '@',
                onClick: '&'
            },
            controller: [function () {
                var ctrl = this;
            }],
            templateUrl: './shared/componentTemplates/component.iconButton.html'
        })
        /**channel icon
         * channel: string: 'sms', appMessaging','fbMessenger','email', whatsApp
         * size: number: [12, 14, 16, 18, 20, 24, 28, 32, 36]
         */
        .component('channelIcon', {
            bindings: {
                channel: '@',
                size: '@', 
            },
            controller: [function () {
                var ctrl = this;
            }],
            templateUrl: './shared/componentTemplates/component.channelIcon.html'
        })
        /**
         * dropdown component - alternative for bootstrap  dropdown
         *  dropdownModel: '=',
                dropdownOptions: iterable
                optionLabel: string
                optionVal: string
                onChange: on change expression
                onChangeParam: on change param
                placeholder: string
                disabled: boolean
                searchEnabled: boolean
                clickOnly: boolean
                disabledOptions:boolean
                inputLike: boolean
                autoScroll: boolean
         * 
         */
        .component('dropdownComponent', {
            bindings: {
                dropdownModel: '=',
                dropdownOptions: '<',
                optionLabel: '<',
                optionVal: '<',
                onChange: '&',
                onChangeParam: '<',
                placeholder: '<',
                disabled: '<',
                searchEnabled: '<',
                clickOnly: '<',
                disabledOptions:'<',
                inputLike: '<',
                autoScroll: '<'
            },
            controller: ['$timeout', "$element", '$scope', function ($timeout, $element, $scope) {
                var ctrl = this;

                function escapeRegExp(string) {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                }

                ctrl.search = {
                    val: ''
                };

                ctrl.variableExist = function(variable){
                    return variable || variable === false;
                };

                ctrl.$onChanges = function () {
                    if(ctrl.dropdownModel!== undefined){
                        ctrl.pickedLabel = ctrl.dropdownModel[ctrl.optionLabel] || ctrl.dropdownModel;
                    }                
                }
                   
                ctrl.$onInit = function () {

                    if(ctrl.variableExist(ctrl.dropdownModel)){
                        var pickedElement = _.find(ctrl.dropdownOptions, function(option){
                            return ctrl.optionVal ? option[ctrl.optionVal] === ctrl.dropdownModel : option === ctrl.dropdownModel
                        });
                        ctrl.pickedLabel = pickedElement[ctrl.optionLabel] || pickedElement[ctrl.optionVal];
                    }

                    if(ctrl.autoScroll){
                        $scope.$watch(function(){
                            return ctrl.isOpen;
                        }, function(){
                            if(ctrl.isOpen){
                                $timeout(function () {
                                    $element.find('.dropdown-menu')[0].scrollIntoView(false);
                                });
                            }
                        })
                    }
                }

                ctrl.isDisabled= function(el){
                    return _.find(ctrl.disabledOptions,function(option){return option==el.id;});
                };
                
                ctrl.searchCrit = function () {
                    if(ctrl.searchEnabled){
                        return function (item) {
                            if (ctrl.optionLabel) {
                                return item[ctrl.optionLabel].search(new RegExp(escapeRegExp(ctrl.search.val), 'i')) >= 0;
                            }
                            else {
                                return item.search(new RegExp(escapeRegExp(ctrl.search.val), 'i')) >= 0;
                            }
                        };
                    }
                    return () => true;
                };

                ctrl.pickElement = function (element) {
                    ctrl.isOpen = false;
                    if (!ctrl.clickOnly) {
                        if (ctrl.optionVal) {
                            ctrl.dropdownModel = element[ctrl.optionVal];
                        }
                        else {
                            ctrl.dropdownModel = element;
                        }
                        ctrl.pickedLabel = ctrl.optionLabel ? element[ctrl.optionLabel] : element
                    }
                    $timeout(function () {
                        if (ctrl.onChange && (ctrl.onChangeParam || ctrl.onChangeParam === 0 || typeof ctrl.onChangeParam === 'boolean')) {
                            ctrl.onChange({ param: ctrl.onChangeParam, index: ctrl.dropdownOptions.indexOf(element) });
                        }
                        else if (ctrl.onChange) {
                            ctrl.onChange({ index: ctrl.dropdownOptions.indexOf(element) });
                        }
                    });
                };

                ctrl.getName = function (picked) {
                    return ctrl.optionLabel ? picked[ctrl.optionLabel] : picked;
                };
            }],
            templateUrl: './shared/componentTemplates/component.comapiDropdown.html'
        })

        /**
         * shorten text
         * letters: number
         * text: string
         * hidePopover: boolean
         */
        .component('shortenText', {
            bindings: {
                letters: '<',
                text: '<',
                hidePopover: '<'
            },
            controller: function () {
                var ctrl = this;
                function shortenText(){
                    ctrl.shortenedText = ctrl.text && typeof ctrl.text === 'string' ? ctrl.text.substr(0, ctrl.letters) + " ..." : ctrl.text;
                }
                ctrl.$onInit = function () {
                    if(typeof(ctrl.text) === 'number'){
                        ctrl.text = ctrl.text.toString();
                    }
                    shortenText();
                    ctrl.htmlText = "<span class='break-word'>" + ctrl.text + "</span>";
                };
                ctrl.$onChanges = function () {
                    shortenText();
                }
            },
            templateUrl: './shared/componentTemplates/component.shortenText.html'
        });
})(window.angular);